{
  "MaxfilterlistlimitLabel": "Maximale filterlijstlimiet:",
  "MaxreportrowdisplimitLabel": "Automatisch wisselen van rapportweergave",
  "MaxfilterlistlimitPlaceholder": "150",
  "MaxreportrowdisplimitPlaceholder": "150",
  "ContentRestriction_SectionHeader": "Inhoudsbeperking",
  "ContentRestriction_SectionPara": "Voor omgevingen met een groot aantal apparaten en\/of ACD-agents kunt u het maximale aantal",
  "NAME": "ContentRestriction"
}